// extracted by mini-css-extract-plugin
export default {"backgroundOverlay":"backgroundOverlay__sFKUsX6Qz7xs","divider":"divider__N7aDokL8USnf"};